document.querySelectorAll('[data-sticky-cta]').forEach((bar) => {
  const parsedThreshold = parseInt(bar.dataset.showAfter, 10);
  const threshold = Number.isNaN(parsedThreshold) ? 700 : parsedThreshold;
  const footer = document.querySelector('footer');
  let footerVisible = false;

  const update = () => {
    const show = window.scrollY >= threshold && !footerVisible;
    bar.classList.toggle('translate-y-full', !show);
    bar.classList.toggle('opacity-0', !show);
  };

  let ticking = false;
  const queueUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      update();
      ticking = false;
    });
  };

  window.addEventListener('scroll', queueUpdate, { passive: true });

  if (footer && 'IntersectionObserver' in window) {
    let hasObservedOnce = false;
    const observer = new IntersectionObserver((entries) => {
      footerVisible = entries[0].isIntersecting;
      if (hasObservedOnce) {
        queueUpdate();
      }
      hasObservedOnce = true;
    });
    observer.observe(footer);
  }

  if (threshold <= 0) {
    queueUpdate();
  }
});
